<template>
  <v-container fluid>
    <div v-for="wasteType in data" :key="wasteType.key">
        <v-container>
          <v-row align="center">
            <h2 class="primary--text pl-4">{{ wasteType.name }}</h2>
            <v-btn
                icon
                v-on:click="removeWasteType(wasteType)"
                class="pl-8"
            >
              <v-icon>mdi-delete</v-icon>
            </v-btn>
          </v-row>
          <v-row>
            <v-col
                cols="12"
                class="pl-4"
            >
              <ServiceAreaVehicles
                  :vehicles="wasteType.vehicles"
                  :waste-type-key="wasteType.key"
                  :service-area-id="serviceAreaId"
                  :remove-vehicle="removeVehicle"
                  :update-vehicle="updateVehicle"
                  :drivers="drivers"
              />
            </v-col>
          </v-row>
          <v-row class="pl-0">
            <v-col
                class="pl-0"
            >
              <v-row justify="end" class="pr-4">
                <AddVehicleType
                    :assigned-vehicle-types="wasteType.vehicles"
                    :get-vehicle-types="getVehicleTypes"
                    :service-area-id="serviceAreaId"
                    :waste-type="wasteType"
                />
              </v-row>
            </v-col>
          </v-row>
        </v-container>
    </div>
  </v-container>
</template>

<script>
import ServiceAreaVehicles from "@/components/service-provider/admin/ServiceAreaVehicles";
import AddVehicleType from "@/components/service-provider/admin/AddVehicleType";
export default {
  name: "ServiceAreaIterator",
  components: { AddVehicleType, ServiceAreaVehicles },
  props: {
    data: Array,
    getVehicleTypes: Function,
    serviceAreaId: String,
    removeVehicle: Function,
    updateVehicle: Function,
    removeWaste: Function,
    drivers: Array
  },
  methods: {
    removeWasteType(waste) {
      if(confirm('Are you sure you want to delete this item?')){
        this.removeWaste(waste, this.serviceAreaId);
      }
    }
  }
}
</script>

<style scoped>

</style>